// extracted by mini-css-extract-plugin
export var fullGrid = "_28-3";
export var pdpPreviewContainer = "_28-1";
export var previewContainer = "_28-0";
export var togglePreviewContainer = "_28-2";